<template>
  <div>
    <vx-card class="mt-3">
      <vs-table :sst="true" pagination max-items="10" v-model="selected" search :data="shipTypes">
      <template slot="header">
        <vs-button
          style="margin-left:5px;margin-top:5px"
          icon-pack="feather"
          icon="icon-plus"
          @click="popupAdd=true"
        >Add ship type</vs-button>
      </template>
      <template slot="thead">
        <vs-th sort-key="id">No.</vs-th>
        <vs-th sort-key="code">Code</vs-th>
        <vs-th sort-key="name">Name</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr v-for="(tr, indextr) in data" :data="tr" :key="indextr">
          <vs-td :data="data[indextr].id">{{ indextr +1}}</vs-td>
          <vs-td :data="data[indextr].code">{{ data[indextr].code }}</vs-td>
          <vs-td :data="data[indextr].name">{{ data[indextr].name }}</vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-button color="danger" class="m-3">Delete</vs-button>
    <vs-button color="warning" class="m-3" >Edit</vs-button>

    </vx-card>
    
    <div class="demo-alignment">
      <vs-popup :active.sync="popupAdd" classContent="popup-example" title="New ship type">
        <vs-input v-model="shipType.code" class="w-full mb-3" placeholder="code" />
        <vs-input v-model="shipType.name" class="w-full mb-3" placeholder="name" />
        <vs-button @click="insertMid()" color="primary" class="w-full" type="filled">Save</vs-button>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import axios from "axios";
import MarkerClusterer from "@google/markerclusterer";
import gmapsInit from "@/gmap/gmaps";
import { SERVER_SYNC_INTERVAL, API_BASE_URL } from "@/constants";
import { lstat } from "fs";

export default {
  data() {
    return {
      shipTypes: this.$store.state.shipTypes,
      shipType: {
        code: "",
        name: ""
      },
      selected: [],
      popupAdd: false,
      popupEdit: false
    };
  },
  mounted() {
    this.$store.dispatch("updateTitlePage", "Setting/Ship type");
  },
  methods: {}
};
</script>
<style>
</style>